import Container, { Service } from 'typedi'
import IHttpClientGetParameters from '@/modules/common/contracts/http-client/http-client-get-parameters.interface'
import IHttpClientPostParameters from '@/modules/common/contracts/http-client/http-client-post-parameters.interface'
import IHttpClientPatchParameters from '@/modules/common/contracts/http-client/http-client-patch-parameters.interface'
import IHttpClientDeleteParameters from '@/modules/common/contracts/http-client/http-client-delete-parameters.interface'
import HttpClient from '@/modules/common/services/http-client.service'

const baseUrl = (eventUuid: string) => `/event/${eventUuid}/event-products`

@Service()
export default class EventProductService {
  public async getEventProducts (eventUuid: string) {
    const httpParams: IHttpClientGetParameters = {
      url: baseUrl(eventUuid),
      requireToken: true
    }
    return await Container.get(HttpClient).get(httpParams)
  }

  public async createEventProduct (eventUuid: string, data: any) {
    const httpParams: IHttpClientPostParameters = {
      url: baseUrl(eventUuid),
      requireToken: true,
      payload: data
    }
    return await Container.get(HttpClient).post(httpParams)
  }

  public async updateEventProduct (eventUuid: string, uuid: string, data: any) {
    const httpParams: IHttpClientPatchParameters = {
      url: `${baseUrl(eventUuid)}/${uuid}`,
      requireToken: true,
      payload: data
    }
    return await Container.get(HttpClient).patch(httpParams)
  }

  public async deleteEventProduct (eventUuid: string, uuid: string) {
    const httpParams: IHttpClientDeleteParameters = {
      url: `${baseUrl(eventUuid)}/${uuid}`,
      requireToken: true
    }
    return await Container.get(HttpClient).delete(httpParams)
  }

  public async reorderEventProducts (eventUuid: string, items: Array<{ uuid: string, display_order: number }>) {
    const httpParams: IHttpClientPatchParameters = {
      url: `${baseUrl(eventUuid)}/reorder`,
      requireToken: true,
      payload: { items }
    }
    return await Container.get(HttpClient).patch(httpParams)
  }
}
